var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRigth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #285647;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.62 14.38 3.5 13.26 9.26 7.5 3.5 1.74 4.62 .62 11.5 7.5 4.62 14.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRigth);
export default __webpack_public_path__ + "static/media/Chevron Rigth.d8e07e1902d221f305e7fee3e1c4d436.svg";
export { ForwardRef as ReactComponent };